import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { FooterSection } from "@components";
import "./ContactUsProfile.scss";
import { ProfileBukopinAPI, BannerProfileAPI } from "@api";
import { useTranslation } from "react-i18next";
import { TitleComponent } from "../../../common/components/TitleComponent";
import { ThumbnailBig } from "../../../common/components";
import MenuProfile from "../MenuProfile";
import Map from "../../../assets/images/image28.png";
import Contact from "../../../assets/images/image27.png";
// import ContactImage from "../../../assets/images/image59.png";

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const ContactUsProfileContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
    margin-top: 0;
  }
`;

const Card = styled.div`
  background: #ffffff;
  box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.05), 0px 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 16px;
  width: 372px;
  @media screen and (max-width: 767px) {
    padding: 10px 15px;
    width: 100% !important;
  }
`;

const Text = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #5e514d;
`;

const Button = styled.div`
  font-weight: bold;
  border: 1px solid rgb(242, 169, 0);
  padding: 10px 20px;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;

  a {
    text-decoration: none;
    color: rgb(242, 169, 0);
  }
`;

const ContainerMap = styled.div`
  padding: 37px 16px;
  @media screen and (max-width: 767px) {
    padding: 0px;
    margin-bottom: 15px;
  }
`;

const Img = styled.img`
  width: 340px;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const ContactUsProfile = function () {
  const { t } = useTranslation();
  const [data, setdata] = useState([]);
  const [shortDesc, setShortDesc] = useState({});
  const [isLoading, setisLoading] = useState(true);

  useEffect(async () => {
    setisLoading(true);
    await getDesc();
    loadData();
  }, []);

  const getDesc = async function () {
    const { data } = await BannerProfileAPI({ loc: "hub_kami" });
    setShortDesc(data.data[0]);
  };
  const loadData = async function () {
    const { data } = await ProfileBukopinAPI("");    
    setdata(data.data);
    setisLoading(false);    
  };
  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <ThumbnailBig
          title={isLoading ? "" : shortDesc.title}
          desc={isLoading ? "" : shortDesc.description}
          img={isLoading ? "" : shortDesc.banner}
        />
      </Container>

      <ContactUsProfileContainer className="container-fluid">
        <div className="m-0 row d-flex align-items-start">
          <div className="p-0 col-lg-9 col-12">
            <ContainerMap
              className="container"
              style={{ backgroundImage: `url(${Map})` }}
            >
              <Card>
                <Img src={Contact} alt="" srcset="" />
                <div className="d-flex w-50 mb-3 align-items-start w-100 mt-4">
                  <svg
                    width="40"
                    height="29"
                    viewBox="0 0 24 24"
                    fill="#5e514d"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-geo-alt"
                      viewBox="0 0 16 16"
                    >
                      <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                      <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                    </svg>
                  </svg>
                  <Text className="ms-2" dangerouslySetInnerHTML={{ __html: isLoading ? "" : data.hubungiKami.alamat }}>                  
                  </Text>                  
                </div>
                <Button className="w-100">
                  <a
                    href={isLoading ? "" : data.hubungiKami.map}                  
                    target="_blank" rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-map"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        className="me-2"
                        d="M15.817.113A.5.5 0 0 1 16 .5v14a.5.5 0 0 1-.402.49l-5 1a.502.502 0 0 1-.196 0L5.5 15.01l-4.902.98A.5.5 0 0 1 0 15.5v-14a.5.5 0 0 1 .402-.49l5-1a.5.5 0 0 1 .196 0L10.5.99l4.902-.98a.5.5 0 0 1 .415.103zM10 1.91l-4-.8v12.98l4 .8V1.91zm1 12.98 4-.8V1.11l-4 .8v12.98zm-6-.8V1.11l-4 .8v12.98l4-.8z"
                      />
                    </svg>{" "}
                    {t("BukadiPeta")}
                  </a>
                </Button>
                <div className="d-flex w-50 mb-3 align-items-start w-100 mt-4">
                  <svg
                    width="1.5em"
                    height="1.5em"
                    viewBox="0 0 24 24"
                    fill="#5e514d"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.857 8.338c.518-.698.704-1.434.118-2.084-1.315-1.84-2.2-2.978-2.754-3.525-1.055-1.042-2.79-.901-3.703-.001-.49.483-.657.649-1.16 1.16C.552 6.697 2.263 12.63 6.812 17.184c4.547 4.552 10.48 6.264 13.292 3.45.465-.447.859-.841 1.169-1.169.895-.946 1.03-2.604-.006-3.682-.532-.552-1.617-1.393-3.534-2.765-.587-.525-1.284-.411-1.922.007-.307.202-.53.406-.952.828l-.767.767c-.1.1-1.47-.586-2.801-1.917C9.96 11.37 9.274 9.999 9.374 9.899l.767-.768c.134-.134.198-.198.28-.285.171-.18.313-.343.436-.508zm4.649 7.695l.766-.767a6.86 6.86 0 01.505-.474c1.68 1.206 2.653 1.965 3.05 2.378.239.248.202.7-.006.919-.287.303-.66.677-1.117 1.118-1.818 1.819-6.608.437-10.479-3.438-3.872-3.876-5.253-8.666-3.449-10.472.502-.509.66-.668 1.144-1.144.182-.179.676-.22.896-.001.427.422 1.22 1.436 2.385 3.06-.06.074-.136.159-.228.255-.067.071-.123.128-.246.25l-.766.767c-1.303 1.303-.193 3.52 1.916 5.632 2.108 2.11 4.326 3.22 5.629 1.917z"
                    ></path>
                  </svg>
                  <Text className="ms-2">
                    {isLoading ? "" : data.hubungiKami.phone}
                  </Text>
                </div>
                <div className="d-flex w-50 mb-3 align-items-start w-100 mt-4">
                  <svg
                    width="1.5em"
                    height="1.5em"
                    viewBox="0 0 24 24"
                    fill="#5e514d"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 7h2V2h12v5h2a2 2 0 012 2v8a2 2 0 01-2 2h-2v3H6v-3H4a2 2 0 01-2-2V9a2 2 0 012-2zm12 0H8V4h8v3zm4 2v8h-2v-2H6v2H4V9h16zm-4 8H8v3h8v-3zm3-6a1 1 0 10-2 0 1 1 0 002 0z"
                    ></path>
                  </svg>
                  <Text className="ms-2">
                    {isLoading ? "" : data.hubungiKami.fax}
                  </Text>
                </div>
              </Card>
            </ContainerMap>
            
            {/* <img src={ContactImage} alt="" /> */}

            <div className="mt-5"
              dangerouslySetInnerHTML={{
                __html: isLoading ? "" : data.hubungiKami.content,
              }}
            ></div>
          </div>
          <div className="d-none d-lg-block col">
            <MenuProfile active={8} />
          </div>
        </div>
      </ContactUsProfileContainer>
      <FooterSection currentPage={t("contact_us")} />
    </div>
  );
};

export default ContactUsProfile;
